import styled from "@emotion/styled";

/**
 * Using half-px to try and match the MdsDropdown SectionDivider, as it
 * is partially cut-off...
 *
 * (We should standardize everything to 1px in the future)
 */
export const SectionDividerMenuItem = styled.div`
  width: 100%;
  height: 0.5px;
  min-height: 0.5px;
  pointer-events: none;
  background-color: ${({ theme }) => theme.colors.border.default};
`;
